import { isPaulAuthorizedCached } from './paulAccess';

export const isAdminAuthenticated = (): boolean => isPaulAuthorizedCached();

export const setAdminAuthenticated = (_value: boolean): void => {
  // noop - admin access is derived from the signed-in authorized account.
};
